<!-- Translated: yes -->
<template>
  <Modal @close="closeModal" :wide="false" width="600px" min-width="500px">
    <h2>Parametrar för synkronisering</h2>

    <h3>Anpassa parametrar</h3>
    <div v-for="(arg, key) in params.args1" :class="arg.length >= 4 && arg[3] ? 'disabled' : ''">
      <div v-if="arg[0] === 'accomodation'" class="field">
        <input type="text" class="input" v-model="accomodationFilter" placeholder="Sök boende" />

        <div class="list" v-if="pools.length">
          <table>
            <tbody v-for="(pool, key) in filteredPools" :class="{active: pool.active}" @click="setPoolActive(pool.id, pool)">
              <tr>
                <th style="text-align:left;">{{ pool.display_name || pool.name }} ({{ pool.unit_count }} st)</th>
              </tr>
              <tr v-for="(unit, k) in pool.units" :class="{active: unit.active}" @click.stop="setUnitActive(unit.id, pool.id)">
                <td>{{ unit.description_title || unit.name }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="list" v-if="!pools.length">
          laddar...
        </div>

        {{ selectedCount || 'Alla' }} boenden valda
      </div>

      <div v-if="arg[0] === 'switch'" class="field">
        <SwitchButton @toggle="toggle" :store="key" :iconscale="2" :value="arg[2]" :sync="false" :labels="{ checked: arg[1], unchecked: arg[1]}" />
      </div>

      <div v-if="arg[0] === 'text'" class="field">
        {{ arg[1] }}
        <input type="text" :value="arg[2]" @keyup="updateArg1($event, key)" />
      </div>

      <div v-if="arg[0] === 'text-readonly'" class="field">
        {{ arg[1] }}
        <input type="text" :value="arg[2]" disabled />
      </div>
    </div>

    <p>&nbsp;</p>

    <h3>Övriga parametrar</h3>
    <div v-for="(arg, key) in params.args2">
      {{ arg }}
    </div>

    <p>&nbsp;</p>

    <button class="button" @click="goOn">Kör</button>
  </Modal>
</template>

<script>
import { mapMutations } from 'vuex';
import Modal from '@/components/components/Modal';
import SwitchButton from '@/components/components/SwitchButton';
import API from '@/classes/API';

export default {
  props: {
    params: {},
  },
  components: {
    Modal,
    SwitchButton,
  },
  data() {
    return {
      outParams: {},
      pools: [],
      accomodationFilter: '',
    };
  },
  async mounted() {
    for (var i in this.params.args1) { // eslint-disable-line
      this.outParams[i] = this.params.args1[i][2];// eslint-disable-line
    } // eslint-disable-line

    if (this.params.args1 && Object.keys(this.params.args1).length) {
      const { data } = await API.get('/grouped?simple=2');
      this.pools = data;
    } else {
      // this.goOn();
    }
  },
  computed: {
    filteredPools() {
      const $filter = this.accomodationFilter.toLocaleLowerCase();
      const pools = JSON.parse(JSON.stringify(this.pools));

      return pools.filter((e) => {
        const poolMatch = (e.display_name || e.name).toLocaleLowerCase().match($filter);

        e.units = e.units.filter(ee => (ee.description_title + ee.name +
          ee.display_name + ee.subtitle + ee.pool_lid +
          e.unit_lid).toLocaleLowerCase()
          .match($filter));

        return e.units.length || poolMatch;
      });
    },
    selectedCount() {
      let count = 0;
      const pools = JSON.parse(JSON.stringify(this.pools));

      pools.forEach((pool) => {
        const units = pool.units.filter(unit => unit.active);
        count += units.length;
      });

      return count;
    },
  },
  methods: {
    ...mapMutations([
      'closeModal',
    ]),
    goOn() {
      this.doTheSync(this.params.command);
    },
    toggle(payload) {
      this.outParams[payload.key] = payload.value;

      console.log(this.outParams);
    },
    setPoolActive(id, p) {
      const $this = this;
      const $pool = $this.pools.find(pool => pool.id === id);

      const count = p.units.length;
      const max = $pool.unit_count;

      $pool.units.forEach((unit, index) => {
        $pool.units[index].active = !$pool.units[index].active;
      });

      this.outParams.accomodationId = this.getAccomodations().join(',');

      if (count !== max) {
        alert(`Området du har valt ut innehåller ${max} boenden, men ditt filter gav bara ${count}. Alla ${max} boenden markerades nu.`);
      }
    },
    setUnitActive(id, poolId) {
      const $this = this;
      const $pool = $this.pools.find(pool => pool.id === poolId);
      const $unit = $pool.units.find(unit => unit.id === id);

      $unit.active = !$unit.active;

      this.outParams.accomodationId = this.getAccomodations().join(',');
    },
    getAccomodations() {
      const pools = JSON.parse(JSON.stringify(this.pools));
      const ids = [];

      pools.forEach((pool) => {
        const units = pool.units.filter(unit => unit.active);

        units.forEach((unit) => {
          ids.push(unit.id);
        });
      });

      return ids;
    },
    updateArg1(e, key) {
      this.outParams[key] = e.target.value;
    },
    doTheSync(command) {
      let newArgs1 = {}; // eslint-disable-line
      let newArgs2 = {}; // eslint-disable-line

      for (let i in this.params.args1) { // eslint-disable-line
        if (this.params.args1[i]) { // eslint-disable-line
          const arg = this.params.args1[i];
          if (arg[0] === 'accomodation' && this.outParams[i]) {
            newArgs1[i] = this.outParams[i];
          } else if (arg[0] === 'switch' && this.outParams[i]) {
            newArgs2[i] = this.outParams[i];
          } else if (arg[0] === 'text' && this.outParams[i]) {
            newArgs2[i] = this.outParams[i];
          }
        } // eslint-disable-line
      } // eslint-disable-line

      for (let i in this.params.args2) { // eslint-disable-line
        if (this.params.args2[i]) { // eslint-disable-line
          newArgs2[this.params.args2[i]] = true; // eslint-disable-line
        } // eslint-disable-line
      } // eslint-disable-line

      API.post('/admin/run-sync-command', {
        command,
        args1: newArgs1,
        args2: newArgs2,
      });

      this.$toast.info('Synkronisering startad', `Kommando: ${command}`, {
        position: 'topRight',
      });

      this.closeModal();
    },
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.field
  border 1px solid black
  margin-bottom 8px
  padding 4px

.list
  overflow-y scroll
  overflow-x hidden
  height 200px

table
  width 100%

td, th
  cursor pointer

h2
  font-size: 24px;
  font-weight: 900;
  text-align: center;
  color: #262626;
  united-heavy()
  margin-bottom: 14px

.active
  background-color light-blue-grey-70

</style>



// WEBPACK FOOTER //
// AdminSyncFields.vue?19f59e5b